import Activator from '@/service/apis/Activator'
import Core from '@/service/apis/Core'

class ActivationSession {
  sanitizeCode(code) {
    if (!this.cfgId) {
      throw new Error('Please startSession first')
    }
    if (code.startsWith('urn:kz:')) {
      // Already sanitized
      return code
    }
    return this.cfgId === -1 ? code : `urn:kz:${this.cfgId}:${code}`
  }

  startSession(code, cfgId) {
    this.targetInfo = null // clean up previous
    this.code = code
    this.cfgId = cfgId
    return Activator.getRollInfo(this.sanitizeCode(code))
      .then((resp) => {
        this.rollInfo = resp.data
        return resp.data
      })
  }

  clear() {
    delete this.code
    delete this.rollInfo
    delete this.targetInfo
    delete this.product
    delete this.schemaAndData
  }

  getCode() {
    return this.code
  }

  getCfgId() {
    return this.cfgId
  }

  getRollInfo() {
    return this.rollInfo
  }

  getTargetInfo() {
    return this.targetInfo
  }

  setProduct(productId) {
    this.product = productId
  }

  getProduct() {
    return this.product
  }

  setSchemaAndData(schemaAndData) {
    this.schemaAndData = schemaAndData
  }

  getSchemaAndData() {
    return this.schemaAndData
  }

  getChannelsWithCodeConfig() {
    return Activator.getChannelsWithCodeConfig()
  }

  getRollTarget(code) {
    return Activator.getRollTarget(this.sanitizeCode(code))
      .then((resp) => {
        this.targetInfo = resp.data
        return resp
      })
  }

  getActivations(code, pageReq) {
    return Activator.getRollSections(this.sanitizeCode(code), pageReq)
  }

  calibrate(firstCode, secondCode) {
    return Activator.calibrateRoll(this.sanitizeCode(firstCode), this.sanitizeCode(secondCode))
  }

  getMetadataSchemas() {
    return Core.getMetadataSchemas({ max: 1000 })
  }

  getSchemaById(id) {
    return Activator.getSchemaById(id)
  }

  activateStrech(firstCode, lastCode, data) {
    const serverData = {
      enable: true,
      metadata: {
        data: data.metadata,
        schema: {
          id: data.schemaId
        }
      },
      product: {
        id: data.productId
      }
    }
    if (data.activationDate) {
      serverData.activeFrom = data.activationDate
    }

    // clean up
    delete this.targetInfo

    return Activator.activateStrech(firstCode, lastCode, serverData)
  }
}

export default new ActivationSession()


// WEBPACK FOOTER //
// ./src/components/pages/activator/service/ActivationSession.js